export class ReplicateInformationErrors {
    _id: string;
    collection: string;
    status: string;
    id: string;
    message: string;
    code: string;
    customerCode: string;
    seller: string;
    sellerCode: string;
    invoiceNumber: string;
    productCode?: Array<string>;
    loan: string;
    branchCode: string;
    errorType: string;
    date: Date;
    constructor() {
        this._id = "";
        this.id = "";
        this.collection = "";
        this.status = "";
        this.message = "";
        this.code = "";
        this.customerCode = "";
        this.seller = "";
        this.sellerCode = "";
        this.invoiceNumber = "";
        this.productCode = [];
        this.loan = "";
        this.branchCode = "";
        this.errorType = "";
        this.date = new Date();
    }
}